import { ui } from "./dom";

export type ToastType = "info" | "success" | "error";

/** 错误信息停留更久;任何 toast 点击即关。 */
const TOAST_DURATION_MS: Record<ToastType, number> = {
  info: 3200,
  success: 3200,
  error: 5200,
};

const LEAVE_ANIMATION_MS = 200;

export function showToast(message: string, type: ToastType = "info"): void {
  const toast = document.createElement("div");
  toast.className = `toast ${type}`;
  toast.textContent = message;
  toast.setAttribute("role", type === "error" ? "alert" : "status");

  let dismissTimer = 0;
  const dismiss = (): void => {
    window.clearTimeout(dismissTimer);
    if (!toast.isConnected) return;
    toast.classList.add("toast--leaving");
    window.setTimeout(() => toast.remove(), LEAVE_ANIMATION_MS);
  };
  toast.addEventListener("click", dismiss);
  dismissTimer = window.setTimeout(dismiss, TOAST_DURATION_MS[type]);

  ui.toastRegion.appendChild(toast);
}
